<template>
  <div
    class="bg-white rounded-2xl shadow-lg border-2 transition-all duration-300 hover:shadow-2xl flex flex-col relative"
    :class="isCurrentPlan ? 'border-primary' : 'border-gray-200 hover:border-primary'"
  >
    <div v-if="isCurrentPlan" class="absolute -top-4 left-1/2 transform -translate-x-1/2 z-10">
      <span class="bg-primary text-white px-4 py-1 rounded-full text-xs font-bold shadow-lg">
        CURRENT PLAN
      </span>
    </div>
    
    <div class="p-8 flex-1 flex flex-col">
      <h3 class="text-2xl font-bold text-gray-900 mb-2">{{ planDetails.name || 'Free Plan' }}</h3>
      
      <!-- Plan Description -->
      <p class="mb-4 text-red-600 font-medium">{{ planDetails.description || 'Basic features to get you started' }}</p>
      
      <!-- Price & Button Section -->
      <div class="border rounded-lg p-4 bg-gray-50 mb-6 flex flex-col items-start">
        <div class="mb-4">
          <div class="text-4xl font-extrabold text-gray-900">${{ planDetails.price || 0 }}</div>
          <div class="text-sm text-gray-500 mt-1">per {{ planDetails.interval || 'forever' }}</div>
        </div>
        
        <button
          v-if="!isCurrentPlan"
          @click="handleDowngrade"
          class="w-full py-3 px-6 rounded-lg font-semibold text-primary border-2 border-primary hover:bg-primary hover:text-white transition-colors duration-200"
        >
          Downgrade to Free
        </button>
        
        <div
          v-else
          class="w-full py-3 px-6 rounded-lg font-semibold text-white bg-primary border-2 border-primary text-center"
        >
          Current Plan
        </div>
      </div>

      <!-- Features List -->
      <ul class="space-y-3 mb-8 flex-1">
        <li v-for="feature in features" :key="feature" class="flex items-start">
          <span class="material-symbols-outlined text-green-500 mr-2 text-xl">check_circle</span>
          <span class="text-gray-700">{{ feature }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FreePlanCard',
  props: {
    planDetails: {
      type: Object,
      required: true
    },
    features: {
      type: Array,
      default: () => []
    },
    isCurrentPlan: {
      type: Boolean,
      default: false
    }
  },
  emits: ['downgrade'],
  methods: {
    handleDowngrade() {
      this.$emit('downgrade');
    }
  }
};
</script>
